import React, { useEffect, useState, Fragment, useContext, useSyncExternalStore } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { Button } from 'react-bootstrap';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import Images from 'assets/images/imageData';
import './pmDashboard.css';
import { Chart } from "react-google-charts";
import pmCheckList from '../pmCheckList';
import { useHistory } from "react-router-dom";
import {Link} from "react-router-dom";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import {ModalBody} from "react-bootstrap";
import DivLayout from 'components/sales/divLayout/divLayout';
import CardSection from 'components/sales/cardSection/cardSection';



const PmSities = ({
  fetchPmDashboard,
  fetchSitesAndGates,
  sitesAndGatesData,
  // getPmSitiesFilterDropDown,
  materialInspected,
  pmdropdownList,
  pmDashboardData,
  userProfile,
  getProfile,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState();
  const [monthId, setMonthId] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [isFiled, setIsFiled] = useState(false);
  const [fileUrl, setFileUrl] = useState('');
  const [uploadModal, setUploadModal] = useState(false);
  const [errorNotFound, setErrorNotFound] = useState(false);
  const [successFull, setSuccessFull] = useState(false);
  const [uploadedSuccessfully, setUploadedSuccessfully] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();
  const [rmTicketCount,setRmTicketCount] = useState([["Status","RM"]]);
  const [pmTicketCount,setPmTicketCount] = useState([["Status","PM"]]);
  const [siteCount,setSiteCount] = useState(["Status","Sites"]);
  const [paymentCount,setPaymentCount] = useState(["Payment Portal","Pending","Hold","Approved","Reject"]);
  const [contractCount,setContractCount] = useState(["Status","Contract"]);
  const [pmCount,setPmCount] = useState([]);
  const { baseUrl } = useContext(BaseUrl);
  const roleId = localStorage.getItem('fusion-role');
  const [materialInspect, setMaterialInspect] = useState(false);
  const [isShowModel, setIsShowModel] = useState(false);
  const [popupData, setPopupData] = useState(null);

  let history = useHistory();

  useEffect(()=> {
    //getProfile();
    if(roleId == 9){
      (async()=> {
        setIsLoading(true)
        const res = await materialInspected()
        if(!res){
            setMaterialInspect(true);
        }
        setIsLoading(false)
      })();
    }
  }, [])
  
  useEffect(() => {
    if(userProfile !== undefined) {
       if(userProfile.popup_show) {
         setIsShowModel(true);
         setPopupData(userProfile.popup_data); 
       }
    }
 },[userProfile]);

 const handleModalHide = () => {
    setIsShowModel(false);
 };

  const headers = [
    'Site Number',
    'Schd. Mnt. Date',
    'Site Type',
    'Client Name',
    'Assigned To',
    'Status',
    'Actions',
  ];

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
      (async () => {
        if(localStorage.getItem('roles')){
          const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
          setIsRoleId(roles);
        }
        if(localStorage.getItem('redirect')!='' && localStorage.getItem('redirect')!=null && localStorage.getItem('redirect')!=undefined){
          window.location.href="/dashboard/vendorPaymentRequestApprovalPage/"+localStorage.getItem('redirect')
        }
       
      })();
      setIsLoading(false);
    }, 1000);
  }, []);

  const headerBtns = () => {
    return (
      <div className="Pm-btn pm-btn-align">
        
      <Fragment>
      
      <Button
              onClick={filterToggle}
              className="filter-hamburger btn btn-transparent"
            >
              <img src={Images?.Filter} alt=""></img>
              {localization.showFilters}
            </Button>
      </Fragment>
        </div>
    );
  };



  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await fetchPmDashboard(filterData, 1);
    await fetchSitesAndGates(filterData);
    setIsLoading(false);
    filterToggle();
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await fetchPmDashboard(filterData, val.selected + 1);

    
    // let filter = filterData === null ? null : filterData;
   
   
    setIsLoading(false);
  };

  useEffect(() => {
    if (fetchPmDashboard !== null)
      (async () => {
        setIsLoading(true);
      const data =  await fetchPmDashboard();
        // await getPmSitiesFilterDropDown();
        // await fetchMonth();
        setIsLoading(false);
      })();
  }, [fetchPmDashboard]);

  useEffect(() => {
    if (fetchSitesAndGates !== null)
      (async () => {
        setIsLoading(true);
        const res =  await fetchSitesAndGates();
        setIsLoading(false);
      })();
  }, [fetchSitesAndGates]);


  useEffect(()=>{
   if(pmDashboardData && pmDashboardData['statusWisePM']){
    var pmArr = [["Status","PM"]];
  pmDashboardData['statusWisePM'].map((value,key) => 
    { 
      pmArr.push([value.status,value.datacount]);
    }  
    );
    setPmTicketCount(pmArr);
   }
  //  statusWisermTicket
   if(pmDashboardData && pmDashboardData['statusWisermTicket']){
    var pmArr = [["Status","PM"]];
  pmDashboardData['statusWisermTicket'].map((value,key) => 
    { 
      pmArr.push([value.status,value.datacount]);
    }  
    );
    setRmTicketCount(pmArr);
   }
  //  siteDataInspection

  if(pmDashboardData && pmDashboardData['siteDataInspection']){
    var dataSite = [["Statuss","Sites",{ role: "style" }]];
    var check = 0;
    pmDashboardData['siteDataInspection'].map((value,key) => 
      { 
        check = 1;
        if(value.stage_status === 2){
          dataSite.push([value.status+' In Progress',value.datacount,"orange"]);
        }else{
          if(value.status_id === 5){
            dataSite.push(["Live",value.datacount,"green"]);
          }else{
            dataSite.push([value.status,value.datacount,"blue"]);
          }
         
        }
        
      }  
      );
    if(check ===0){
      dataSite.push(['No Data',0,"red"]);
    }
    setSiteCount(dataSite);
   }

   if(pmDashboardData && pmDashboardData['advance_payment']){
    var dataPayment = [["Payment Portal","Pending","Hold","Approved","Reject"]];
    var advPayment = pmDashboardData['advance_payment'];
    // if(advPayment.pending){
      dataPayment.push(["Advance",advPayment.pending,advPayment.hold,advPayment.approved,advPayment.reject])
    // }
    // if(pmDashboardData['adjustment_payment'].pending){
      var adjPayment = pmDashboardData['adjustment_payment'];
      dataPayment.push(["Adjustment",adjPayment.pending,adjPayment.hold,adjPayment.approved,adjPayment.reject])
    // }
    // if(pmDashboardData['payment'].pending){
      var payment = pmDashboardData['payment'];
      dataPayment.push(["Payment",payment.pending,payment.hold,payment.approved,payment.reject])
    // }

    setPaymentCount(dataPayment);
   }

   if(pmDashboardData && pmDashboardData['contract']){
    var dataCont = [["Status","Contract",{ role: "style" }]];
    var checkC = 0;
    pmDashboardData['contract'].map((value,key) => 
      { 
        checkC = 1;
        dataCont.push([value.status,value.datacount,"blue"]);
        
      }  
      );
    if(checkC ===0){
      dataCont.push(['No Data',0,"red"]);
    }
    setContractCount(dataCont);
   }

  },[pmDashboardData]);


  const options = {
    chart: {
      title: "Site Stages",
      subtitle: "Report",
    },
    
    is3D: true,
  };

  const optionsBar = {
    chart: {
      title: "Payment Portal",
      subtitle: "Report",
    },
    
    is3D: true,
  };
  const optionsCont = {
    chart: {
      title: "Contract",
      subtitle: "Report",
    },
    
    is3D: true,
  };
  const optionsPm = {
    title: "Preventive Maintenance Sites",
    backgroundColor: {
      gradient: {
        // Start color for gradient.
        color1: '#ffffff',
        // Finish color for gradient.
        color2: '#4c93db',
        x1: '0%', y1: '0%',
        x2: '100%', y2: '100%',
        // useObjectBoundingBoxUnits: true
      },
    },
    is3D: true,
  };
  const optionsRm = {
    title: "Reactive Maintenance Tickets",
    backgroundColor: {
      gradient: {
        // Start color for gradient.
        color1: '#ffffff',
        // Finish color for gradient.
        color2: '#4c93db',
        x1: '0%', y1: '0%',
        x2: '100%', y2: '100%',
        // useObjectBoundingBoxUnits: true
      },
    },
    is3D: true,
  };

  const getpmclick = (e) => {
    if(e.targetID){
     var id = e.targetID.split('#');
     if(id && id[1]) {
      //  'fromFilterDate' 
			// 'toFilterDate'
      

       if(pmDashboardData['statusWisePM'] && pmDashboardData['statusWisePM'][id[1]]){
         var pmcheck = pmDashboardData['statusWisePM'][id[1]];
         if(pmDashboardData['requestData'] && pmDashboardData['requestData']){
           console.log(pmDashboardData['requestData']);
          pmDashboardData['requestData']['status'] = pmcheck.statusId;
          localStorage.setItem("dashBoardFilter", JSON.stringify(pmDashboardData['requestData']));
        }
         if(pmcheck.statusId === 5 || pmcheck.statusId === 7 ){
          history.push('/dashboard/approvals/pm-sites');
         }else{
          history.push('/dashboard/pm-sities');
          
         }
       }

     }
    }
  };

  const handlePmClick = (val) => {
    if(val){ 
      var id = val;
      if(id) { 
        if(sitesAndGatesData['pm_sites_data'][0]['total_pm'] > 0){
          var pmStatusId = id;
          if(pmDashboardData['requestData'] && pmDashboardData['requestData']){
          pmDashboardData['requestData']['status'] = pmStatusId;
          localStorage.setItem("dashBoardFilter", JSON.stringify(pmDashboardData['requestData']));
        }
          if(pmStatusId === 5 || pmStatusId === 3 ){
           history.push('/dashboard/approvals/pm-sites');
          }else{
           history.push('/dashboard/pm-sities');
           
          }
        }
 
      }
     }
  }

  const handleRmClick = (val) => {
    if(val){ 
      var id = val;
      if(id) { 
        if(sitesAndGatesData['rm_tickets_data'][0]['total_rm'] > 0){
          var rmStatusId = id;
          if(pmDashboardData['requestData'] && pmDashboardData['requestData']){
          pmDashboardData['requestData']['status'] = rmStatusId;
          localStorage.setItem("dashBoardFilter", JSON.stringify(pmDashboardData['requestData']));
        }
          if(rmStatusId === 5 || rmStatusId === 3 ){
           history.push('/dashboard/approvals/rm-tickets');
          }else{
           history.push('/dashboard/rm-tickets');
           
          }
        }
 
      }
     }
  }

  const handleSitesClick = (val) => {
    if(val){ 
      var id = val;
      if(id) { 
        if(sitesAndGatesData['live_sites'] > 0 || sitesAndGatesData['hold_sites'] > 0 || sitesAndGatesData['wip_sites'] > 0)
        { if(id === 'all') {
             id = '';
          }
          var toDate = pmDashboardData['requestData']['toFilterDate']; 
          var fromDate = pmDashboardData['requestData']['fromFilterDate']; 
          // console.log('to date' + toDate + ' from date ' + fromDate);
          // return false;
          var data = {"site_no":"","client_name":"","site_type":"","area_id":"","reportee":"","status_id":id,"city_id":"","commercial_type_id":"","to_date":toDate,"from_date":fromDate}; 
          if(pmDashboardData['requestData'] && data){
            localStorage.setItem("installationContractList", JSON.stringify(data));
          }
          history.push('/dashboard/site-listing');  
        }
      }
     }
  };

  const getrmclick = (e) => {
    if(e.targetID){ 
     var id = e.targetID.split('#');
     if(id && id[1]) {
      console.log(id[1]);
       if(pmDashboardData['statusWisermTicket'] && pmDashboardData['statusWisermTicket'][id[1]]){
         var pmcheck = pmDashboardData['statusWisermTicket'][id[1]];
         if(pmDashboardData['requestData'] && pmDashboardData['requestData']){
         pmDashboardData['requestData']['status'] = pmcheck.statusId;
         localStorage.setItem("dashBoardFilter", JSON.stringify(pmDashboardData['requestData']));
       }
         if(pmcheck.statusId === 5 || pmcheck.statusId === 3 ){
          history.push('/dashboard/approvals/rm-tickets');
         }else{
          history.push('/dashboard/rm-tickets');
          
         }
       }

     }
    }
  };

  
  const getsiteclick = (e) => {
    if(e.targetID){
    //  var id = e.targetID.split('#');
     history.push('/dashboard/site-listing');
    }
  };

  const getpaymentclick = (e) => {
    if(e.targetID){
     var id = e.targetID.split('#');
    // console.log(id); return false;
    // PENDING HOLD APPROVED REJECT
     if(id[1] === "0"){
      pmDashboardData['requestData']['action_status'] = 'PENDING';
     }else if(id[1] === "1"){
      pmDashboardData['requestData']['action_status'] = 'HOLD';
     }else if(id[1] === "2"){
      pmDashboardData['requestData']['action_status'] = 'APPROVED';
     }
     else if(id[1] === "3"){
      pmDashboardData['requestData']['action_status'] = 'REJECT';
     }
     else{
      pmDashboardData['requestData']['action_status'] = '';
     }

    //  .. TYPE
     if(id[2] === "0"){
      pmDashboardData['requestData']['request_type'] = 'ADVANCE';
      
     }else if(id[2] === "1"){
      pmDashboardData['requestData']['request_type'] = 'ADJUSTMENT';
      
     }else if(id[2] === "2"){
      pmDashboardData['requestData']['request_type'] = 'PAYMENT';
      
     }else{
      pmDashboardData['requestData']['request_type'] = '';
      
     }

      if(pmDashboardData['requestData'] && pmDashboardData['requestData']){
            localStorage.setItem("dashBoardFilter", JSON.stringify(pmDashboardData['requestData']));
          }
      history.push('/dashboard/paymentRequest');
     
    }
  };

  

  return (
    <Layout
      title={`Dashboard`}
      Buttons={(isRoleId === 17 || isRoleId === 16 || isRoleId === 10 || isRoleId === 8 || isRoleId === 3 || isRoleId === 4 || isRoleId === 5 || isRoleId === 6 || isRoleId === 14 || isRoleId === 15)? headerBtns : ''}
      className={isFiled ? 'requiredFileds' : ''}
      isLoading={isLoading}
    >

        {materialInspect &&
            <ModalPop
                title={localization.ToolkitAlert}
                show={materialInspect}
                handleModalHide={() => {setMaterialInspect(false)}}
                keyboard
                backdrop
            >
                <p>You have not filled Toolkit Inspection Form yet!!</p>
                <Link
                    to={`${baseUrl}/toolkit-inspection-form`}
                    className="btn btn-primary d-md-inline-block"
                >
                    Fill Toolkit Inspection Form
                    <img src={Images?.ArrowRight} alt="" />
                </Link>
            </ModalPop>
        }

    {(isRoleId === 17 || isRoleId === 16 || isRoleId === 10 || isRoleId === 8 || isRoleId === 3 || isRoleId === 4 || isRoleId === 5 || isRoleId === 6 || isRoleId === 14 || isRoleId === 15) &&
      <div className="row">
        <div className="col-12" style={{"background-image": "linear-gradient(#99ccff, #ffffff)"}}>
            <h3 style={{"fontSize":"15px"}}>
            Date : {pmDashboardData['requestData'] && pmDashboardData['requestData']['fromDate']} to  {pmDashboardData['requestData'] && pmDashboardData['requestData']['toDate']}
            </h3>
        </div>
      </div>
    }
    {/* profile */}
    <div className="row">
      <div className="col-12">
        <div className="card" style={{"borderRadius": "15px"}}>
          <div className="card-body p-4">
            <div className="d-flex text-black">
            {window.screen.width < 1000?
              ''
              :
              <div className="col-md-4 col-sm-12 col-xs-12">
              <div className="flex-shrink-0">
                <img src={Images?.parkplusLogo} alt="Park +" className="img-fluid" style={{"width": "30%" ,"borderRadius": "10px"}}/>
              </div>
              </div>
              }
              
              <div className="col-md-8 col-sm-12 col-xs-12">
              <div className="flex-grow-1 ms-3">
                <h5 className="mb-1">{userProfile && userProfile.name}</h5>
                <p className="mb-2 pb-1" style={{"color": "#2b2a2a"}}>{
                userProfile && userProfile.roles && userProfile?.roles[0]?.title
                  ? userProfile?.roles[0]?.title
                  : localization.na
              }</p>
                <p className="mb-2 pb-1" style={{"color": "#2b2a2a"}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telephone" viewBox="0 0 16 16">
                <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
              </svg> 
              <span className="ml-1">
                  {
                userProfile?.mobile_number
                  ? userProfile?.mobile_number
                  : localization.na
              } 
              </span>
              <span className="ml-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope" viewBox="0 0 16 16">
              <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
            </svg>
              <span className="ml-1">
                  {
                userProfile?.email
                  ? userProfile?.email
                  : localization.na
              }
              </span>
              </span>
              </p>
                
                <div className="d-flex pt-1">
                  {/* <button type="button" className="btn btn-outline-primary me-1 flex-grow-1">Chat</button>
                  <button type="button" className="btn btn-primary flex-grow-1">Follow</button> */}
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
   
    </div>  
    <br/>
    {/* profile */}
    {(userProfile && userProfile.roles && (userProfile.roles[0].id === 16 || userProfile.roles[0].id === 10 )) && 

        <div className="row slide-in-left">
          <div className="col-md-6 col-sm-12 col-xs-12">
          
            <Chart
              chartType="PieChart"
              data={pmTicketCount}
              options={optionsPm}
              width={"100%"}
              height={"400px"}
              chartEvents={[
                {
                  eventName: "ready",
                  callback: ({ chartWrapper, google }) => {
                    const chart = chartWrapper.getChart();
                    google.visualization.events.addListener(chart, "click", e => {
                      getpmclick(e);
                      console.warn("onclick : ", e);
                    });
                  
                  }
                }
              ]}
            />
          </div>
          <div className="col-md-6 col-sm-12 col-xs-12">
          <Chart
            chartType="PieChart"
            width="100%"
            height="400px"
            data={rmTicketCount}
            options={optionsRm}
            chartEvents={[
              {
                eventName: "ready",
                callback: ({ chartWrapper, google }) => {
                  const chart = chartWrapper.getChart();
                  google.visualization.events.addListener(chart, "click", e => {
                    getrmclick(e);
                    // console.warn("onclick : ", e);
                  });
                
                }
              }
            ]}
          />
          </div>
        </div>
      }
      <br/>
      {(userProfile && userProfile.roles && (userProfile.roles[0].id === 16 || userProfile.roles[0].id === 8 || userProfile.roles[0].id === 17)) &&     
            <div className="panel-card">
              <div className="card-header">Site Stages</div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <Chart
                      chartType="ColumnChart"
                      width="100%"
                      height="400px"
                      data={siteCount}
                      options={options}
                      chartEvents={[
                        {
                          eventName: "ready",
                          callback: ({ chartWrapper, google }) => {
                            const chart = chartWrapper.getChart();
                            google.visualization.events.addListener(chart, "click", e => {
                              getsiteclick(e);
                              // console.warn("onclick : ", e);
                            });
                          
                          }
                        }
                      ]}
                    />
                  </div>
                </div>
            </div>
            </div>
          
    }

{(isRoleId === 3 || isRoleId === 4 || isRoleId === 5 || isRoleId === 6 || isRoleId === 14 || isRoleId === 15 || isRoleId == 16) && 
<div className="panel-card">
              <div className="card-header">Payment Portal</div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <Chart
                      chartType="ColumnChart"
                      width="100%"
                      height="400px"
                      data={paymentCount}
                      options={optionsBar}
                      chartEvents={[
                        {
                          eventName: "ready",
                          callback: ({ chartWrapper, google }) => {
                            const chartPayment = chartWrapper.getChart();
                            google.visualization.events.addListener(chartPayment, "click", e => {
                              getpaymentclick(e);
                              console.warn("onclick : ", e);
                            });
                          
                          }
                        }
                      ]}
                    />
                  </div>
                </div>
            </div>
            </div>
          
        }

        {/* Installation */}
        {(userProfile && userProfile.roles && (userProfile.roles[0].id === 16 || userProfile.roles[0].id === 8 ||
          userProfile.roles[0].id === 9 || userProfile.roles[0].id === 17)) &&
        <>
        <div className="cbox">
        <div className="card-body">
            <div className="table-body">
              <div className="d-flex">
              {/* <div className="header-body col-2"><b>Installation</b></div> */}
                <div className="col-12 div-bp">
                  <table border="1" className="table table-bordered kmb dashboard-table">
                  <thead>
                    <tr>
                      <th className='border-skyblue'></th>
                      <th>WIP</th> 
                      <th>HOLD</th> 
                      <th>LIVE</th> 
                    </tr>
                  </thead>
                  <tbody>
                  <tr className='rw-clr'>
                    <td className='td-style' rowspan="2">Installation</td>
                    <td>
                     <div className='d-flex text-center'>
                      <div className="col-6 odd-line">Sites</div>
                      <div className="col-6">Gates</div>
                     </div>
                    </td>
                    <td>
                    <div className='d-flex text-center'>
                      <div className="col-6 odd-line">Sites</div>
                      <div className="col-6">Gates</div>
                     </div>
                    </td>
                    <td>
                    <div className='d-flex text-center'>
                      <div className="col-6 odd-line">Sites</div>
                      <div className="col-6">Gates</div>
                     </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <div className='d-flex text-center'>
                      <div className="col-6 odd-line">
                       <a className='def-cursor' onClick={() => handleSitesClick('all')}>
                        {sitesAndGatesData?.wip_sites}
                       </a>
                      </div> 
                      <div className="col-6">{sitesAndGatesData?.wip_gates ? sitesAndGatesData?.wip_gates : 0 }</div>
                     </div>
                    </td>
                    <td>
                    <div className='d-flex text-center'>
                      <div className="col-6 odd-line">
                        <a className='def-cursor' onClick={() => handleSitesClick(5)}>
                         {sitesAndGatesData?.hold_sites}
                        </a>
                      </div>
                      <div className="col-6">{sitesAndGatesData?.hold_gates}</div>
                     </div>
                    </td>
                    <td>
                    <div className='d-flex text-center'>
                      <div className="col-6 odd-line">
                        <a className='def-cursor' onClick={() => handleSitesClick(2)}>
                         {sitesAndGatesData?.live_sites}
                        </a>
                       </div>
                      <div className="col-6">{sitesAndGatesData?.live_gates}</div>
                     </div>
                    </td>
                  </tr>
                  </tbody>
                  </table>
                </div>
              </div>
           </div>
          </div>
          </div>

          <div div className="cbox">
          <div className="card-body">
            <div className="table-body">
              <div className="d-flex">
                <div className="col-12 div-bp">
                  <table border="1" className="table table-bordered kmb dashboard-table">
                  <thead>
                    <tr>
                      <th style={{'width':'18%'}}>WIP Stages(Till Now)</th> 
                      <th>0-3 Days</th> 
                      <th>4-7 Days</th> 
                      <th>8-15 Days</th>
                      <th>16-20 Days</th>
                      <th>21-30 Days</th> 
                      <th>&gt; 30 Days</th>  
                    </tr>
                  </thead>
                  <tbody>
                  {sitesAndGatesData?.wip_array && sitesAndGatesData?.wip_array.map((item, x) => 
                  <>
                  {item.name !== '' &&
                  <tr>
                    <td>{item.name}</td>
                    <td>{item.days_0_3}</td>
                    <td>{item.days_4_7}</td>
                    <td>{item.days_8_15}</td>
                    <td>{item.days_16_20}</td>
                    <td>{item.days_21_30}</td>
                    <td style={{'text-align':'center'}}>{item.more_then_30_days}</td>
                  </tr>
                  }
                  </>
                  )}
                  </tbody>
                  </table>
                </div>
              </div>
           </div>
          </div>
          </div>

          <div div className="cbox">
          <div className="card-body">
            <div className="table-body">
              <div className="d-flex">
                <div className="col-12 div-bp">
                  <table border="1" className="table table-bordered kmb dashboard-table">
                  <thead>
                    <tr>
                      <th style={{'width':'18%'}}>Hold Stages(Till Now)</th> 
                      <th>0-3 Days</th> 
                      <th>4-7 Days</th> 
                      <th>8-15 Days</th>
                      <th>16-20 Days</th>
                      <th>21-30 Days</th> 
                      <th>&gt; 30 Days</th>  
                    </tr>
                  </thead>
                  <tbody>
                  {sitesAndGatesData?.hold_array && sitesAndGatesData?.hold_array.map((item, x) => 
                  <>
                  {item.name !== '' &&
                  <tr>
                    <td>{item.name}</td>
                    <td>{item.days_0_3}</td>
                    <td>{item.days_4_7}</td>
                    <td>{item.days_8_15}</td>
                    <td>{item.days_16_20}</td>
                    <td>{item.days_21_30}</td>
                    <td style={{'text-align':'center'}}>{item.more_then_30_days}</td>
                  </tr>
                  }
                  </>
                  )}
                  </tbody>
                  </table>
                </div>
              </div>
           </div>
          </div>
          </div>
           </>
          }
     
          {/* Installation End */}

          {/* Rm */}
          {(userProfile && userProfile?.roles && (userProfile.roles[0].id === 16 || userProfile.roles[0].id === 10 ||
          userProfile.roles[0].id === 9)) &&
          <>
          <div className="cbox">
          <div className="card-body">
            <div className="table-body">
              <div className=" d-flex">
                <div className="col-12 div-bp">
                  <table border="1" className="table table-bordered kmb dashboard-table">
                  <thead>
                    <tr>
                      <th className='border-skyblue'></th>
                      <th>Total RM</th> 
                      {/* <th>Carry Forward</th> 
                      <th>New Cases Added</th>  */}
                      <th>Total Closed</th> 
                      <th>Total Open</th>
                      <th>Completed</th> 
                    </tr>
                  </thead>
                  <tbody>
                  {sitesAndGatesData?.rm_tickets_data && sitesAndGatesData?.rm_tickets_data.map((item, x) => 
                  <tr>
                    <td className='td-style'><span className='span-header'>RM</span></td>
                    <td>{item.total_rm}</td>
                    {/* <td>{item.rm_carry_forward}</td>
                    <td>{item.rm_new_cases}</td> */}
                    <td><a className='def-cursor' onClick={() => handleRmClick(3)}>{item?.rm_closed}</a></td>
                    <td><a className='def-cursor' onClick={() => handleRmClick(1)}>{item?.rm_open}</a></td>
                    <td style={{'text-align':'center'}}><a className='def-cursor' onClick={() => handleRmClick(5)}>{item?.rm_complete}</a></td>

                    
                  </tr>
                  )}
                  </tbody>
                  </table>
                </div>
              </div>
           </div>
          </div>
          </div>

          <div className="cbox">
          <div className="card-body">
            <div className="table-body">
              <div className="d-flex">
                <div className="col-12 div-bp">
                  <table border="1" className="table table-bordered kmb dashboard-table">
                  <thead>
                    <tr>
                      <th className='border-skyblue'></th>
                      <th>&lt; 2 Days</th> 
                      <th>2 To 5 Days</th> 
                      <th>6 To 10 Days</th> 
                      <th>11 To 20 Days</th> 
                      <th>&gt; 20 Days</th>
                      <th>Grand Total</th> 
                    </tr>
                  </thead>
                  <tbody>
                  {sitesAndGatesData?.rm_tickets_age && sitesAndGatesData?.rm_tickets_age.map((item, x) => 
                  <tr>
                    <td className='td-style'><span className='span-header'>Total RM Aging Wise</span></td>
                    <td>{item.less_than_2}</td>
                    <td>{item.between_2_5}</td>
                    <td>{item.between_6_10}</td>
                    <td>{item.between_11_20}</td>
                    <td>{item.above_20}</td>
                    <td style={{'text-align':'center'}}>{item.total_rm}</td>
                  </tr>
                  )}
                  </tbody>
                  </table>
                </div>
              </div>
           </div>
          </div>
          </div>

        <div className="cbox">
        <div className="card-body">
            <div className="table-body">
              <div className="d-flex">
                <div className="col-12 div-bp">
                  <table border="1" className="table table-bordered kmb dashboard-table">
                  <thead>
                    <tr>
                      <th className='border-skyblue'></th>
                      <th>&lt; 2 Days</th> 
                      <th>2 To 5 Days</th> 
                      <th>6 To 10 Days</th> 
                      <th>11 To 20 Days</th> 
                      <th>&gt; 20 Days</th>
                      <th>Grand Total</th> 
                    </tr>
                  </thead>
                  <tbody>
                  {sitesAndGatesData?.l2_tickets_data && sitesAndGatesData?.l2_tickets_data.map((item, x) => 
                  <tr>
                    <td className='td-style'><span className='span-header'>L2 Tickets Aging Wise</span></td>
                    <td>{item.less_than_2}</td>
                    <td>{item.between_2_5}</td>
                    <td>{item.between_6_10}</td>
                    <td>{item.between_11_20}</td>
                    <td>{item.above_20}</td>
                    <td style={{'text-align':'center'}}>{item.total_l2}</td>
                  </tr>
                  )}
                  </tbody>
                  </table>
                </div>
              </div>
           </div>
          </div>
          </div>

        {sitesAndGatesData?.pm_sites_data && sitesAndGatesData?.pm_sites_data.length > 0 &&
        <div className="cbox">
        <div className="card-body">
            <div className="table-body">
              <div className="d-flex">
                <div className="col-12 div-bp">
                  <table border="1" className="table table-bordered kmb dashboard-table">
                  <thead>
                    <tr>
                      <th className='border-skyblue'></th>
                      <th>Total PM</th> 
                      <th>PM Done Till ({sitesAndGatesData?.pm_sites_data[0].date})</th> 
                      <th>PM Pending Till ({sitesAndGatesData?.pm_sites_data[0].date})</th> 
                      <th>PM Open Till ({sitesAndGatesData?.pm_sites_data[0].date})</th>
                      <th>% Compliance</th> 
                    </tr>
                  </thead>
                  <tbody>
                  {sitesAndGatesData?.pm_sites_data && sitesAndGatesData?.pm_sites_data.map((item, x) => 
                  <tr>
                    <td className='td-style'><span className='span-header'>Site PM</span></td>
                    <td>{item.total_pm}</td>
                    <td><a className='def-cursor' onClick={() => handlePmClick(5)}>{item.total_approved}</a></td>
                    <td><a className='def-cursor' onClick={() => handlePmClick(4)}>{item.total_approval_pending}</a></td>
                    <td><a className='def-cursor' onClick={() => handlePmClick(1)}>{item.total_open}</a></td>
                    <td>NA</td>
                  </tr>
                  )}
                  </tbody>
                  </table>
                </div>
              </div>
           </div>
          </div>
          </div>
          }
          </>
          }

          {(userProfile && userProfile.roles && (userProfile.roles[0].id === 10)) &&
          <>
          <div className="cbox">
          <div className="card-body">
            <div className="table-body">
              <div className="d-flex">
                <div className="col-12 div-bp">
                  <table border="1" className="table table-bordered kmb dashboard-table">
                  <thead>
                    <tr>
                      <th className='td-style w-18'>Total RM Aging Wise</th>
                      <th>&lt; 2 Days</th> 
                      <th>2 To 5 Days</th> 
                      <th>6 To 10 Days</th> 
                      <th>11 To 20 Days</th> 
                      <th>&gt; 20 Days</th>
                      <th>Grand Total</th> 
                    </tr>
                  </thead>
                  <tbody>
                  {sitesAndGatesData?.rm_engg && sitesAndGatesData?.rm_engg.map((item, x) => 
                  <tr>
                    <td>{item.name}</td>
                    <td>{item.days_0_2}</td>
                    <td>{item.days_2_5}</td>
                    <td>{item.days_6_10}</td>
                    <td>{item.days_11_20}</td>
                    <td>{item.more_than_20}</td>
                    <td style={{'text-align':'center'}}>{item.total}</td>
                  </tr>
                  )}
                  </tbody>
                  </table>
                </div>
              </div>
           </div>
          </div>
          </div>
          </>
          }

          {/* Rm End */}



          {/* For MOM */}
          {(userProfile && userProfile.roles && (userProfile.roles[0].id === 16 || userProfile.roles[0].id === 14 ||
          userProfile.roles[0].id === 15)) &&
          <>
           <div className="cbox">
            <div className="card-body">
              <div className="table-body">
                <div className="d-flex">
                  <div className="col-12 div-bp">
                    <table border="1" className="table table-bordered kmb dashboard-table">
                    <thead>
                      <tr>
                        <th className='border-skyblue'></th>
                        <th>Meetings Done</th> 
                        <th>MOM Send</th>
                      </tr>
                    </thead>
                    <tbody>
                    {sitesAndGatesData?.momData && sitesAndGatesData?.momData.map((item, x) => 
                    <tr>
                    <td className='td-style'><span className='span-header'>Meetings/MOM</span></td>
                      <td>{item.total_meeting}</td>
                      <td>{item.total_mom_send}</td>
                    </tr>
                    )}
                    </tbody>
                    </table>
                  </div>
                </div>
             </div>
            </div>
           </div>
           </>
          } 

          {(userProfile && userProfile.roles && (userProfile.roles[0].id === 14 ||
          userProfile.roles[0].id === 15 || userProfile.roles[0].id === 16 || userProfile.roles[0].id === 17)) &&
          <>
          <div className="cbox">
           <div className="card-body">
            <div className="table-body">
              <div className="d-flex">
                <div className="col-12 div-bp">
                  <table border="1" className="table table-bordered kmb dashboard-table">
                  <thead>
                    <tr>
                      <th className='td-style w-5'>S No.</th>
                      <th>Site Number</th> 
                      <th>Business</th>
                      <th>Meeting Agenda</th>
                      <th>Scheduled Date</th> 
                      <th>BA Manager</th>
                      <th>Meeting Send</th>
                      <th>Send Mom</th>
                    </tr>
                  </thead>
                  <tbody>
                  {sitesAndGatesData?.pendingMom && sitesAndGatesData?.pendingMom?.length > 0 && sitesAndGatesData?.pendingMom.map((item, x) =>
                  <>
                  {item.meeting_id == null &&
                    <tr>
                      <td>{x+1}</td>
                      <td>{item.site_no}</td>
                      <td>{item.client_name}</td>
                      <td>{item.subject}</td>
                      <td>{item.scheduled_date}</td>
                      <td>{item.scheduled_date}</td>
                      <td>No</td>
                      <td style={{'text-align':'center'}}>
                      <Link
                        to={`${baseUrl}/brand-activation/create-mom/${item.site_id}/${item.id}`}
                        className=""
                        >
                        Send
                      </Link>
                      </td>
                    </tr>
                  }
                  </>  
                  )}
                  </tbody>
                  </table>
                </div>
              </div>
            </div>
           </div>
           </div>
          </>
          }
          {/* End MOM */}

        {(isRoleId === 3 || isRoleId === 4 || isRoleId === 5 || isRoleId === 6) && 
          <div className="panel-card">
              {/* <div className="card-header">Payment Portal</div> */}
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <Chart
                      chartType="Bar"
                      width="100%"
                      height="400px"
                      data={contractCount}
                      options={optionsCont}
                      chartEvents={[
                        {
                          eventName: "ready",
                          callback: ({ chartWrapper, google }) => {
                            const chart = chartWrapper.getChart();
                            google.visualization.events.addListener(chart, "click", e => {
                              getsiteclick(e);
                              // console.warn("onclick : ", e);
                            });
                          
                          }
                        }
                      ]}
                    />
                  </div>
                </div>
            </div>
            </div>
  }
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        // statusId={0}
        listFilterData={pmdropdownList?.site_type ? pmdropdownList : null}
        pmdashBoardList={true}
      />

     <ModalPop
        title={localization.scheduledActivity}
        show={isShowModel}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
       <div>
        {/* <CardSection title={'Details'}> */}
          <div className="details-listing">
            <DivLayout
                heading={'Site Number'}
                data={popupData?.site_no}
            />
            <DivLayout
                heading={'Activity Type'}
                data={popupData?.type}
            />
            <DivLayout
                heading={'Maintenance Date'}
                data={popupData?.maintaince_date}
            />
            <DivLayout
                heading={'Time Slot'}
                data={popupData?.slot}
            />
            <DivLayout
                heading={'Assigned To'}
                data={popupData?.assigned_to_user}
            />
          </div>  
        {/* </CardSection> */}
        <div className="line"></div>
       </div>
        <div className="text-center">
          <a className="btn btn-primary text-center" href={popupData?.url}>{localization.goToList}</a>
        </div>
      </ModalPop>

     
    </Layout>
  );
};
export default PmSities;
